import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { BodyTypeWarnComponent } from '../common/modals/body-type-warn/body-type-warn.component';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NoVehicleIdGuard implements CanActivate {
  constructor(
    public modalService: BsModalService,
    public activatedRoute: ActivatedRoute
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const vehicleId = route.queryParamMap.get('vehicle_id');
    const role = route.queryParamMap.get('role');

    // these two values will be passed from the iframe
    if (
      vehicleId !== null &&
      [
        'admin',
        'purchaser',
        'purchasemanager',
        'salesperson',
        'salesmanager',
        'estimator',
        'new_salesman',
        'reconditioning_manager',
        'media_admin',
        'evaluator',
        'qc',
        'external_estimator',
        'reconditioning_executive',
        'yard_manager',
        'coo',
        'logistics_director',
        'vam_chef'
      ].includes(role)
    ) {
      localStorage.setItem('vehicleId', vehicleId);
      return true;
    }

    // it means that the route is called without those values
    else {
      const locallyStoredVehicleId = localStorage.getItem('vehicleId');

      if (locallyStoredVehicleId === null) {
        const warnModal = this.modalService.show(BodyTypeWarnComponent, {
          class: 'bodyTypeWarn'
        });
        warnModal.content.content = 'Please register for a car first.';
        return false;
      }

      return true;
    }
  }
}
